<template>
  <div class="my-5 text-center">
    <img width="250px" src="../../assets/images2.0/icons/empty_job_alert.svg" alt="empty job alert icon"/>
    <div class="mt-3 empty-referral-text">{{$t("myreferrals.empty.message")}}</div>
  </div>
</template>

<script>
export default {};
</script>
